/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetManyRecoveringCharacteristicResponseDto } from '../../models/get-many-recovering-characteristic-response-dto';

export interface GetManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params {

/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
  fields?: Array<string>;

/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
  s?: string;

/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
  filter?: Array<string>;

/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
  or?: Array<string>;

/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
  sort?: Array<string>;

/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
  join?: Array<string>;

/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
  limit?: number;

/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
  offset?: number;

/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
  page?: number;

/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
  cache?: number;
}

export function getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic(http: HttpClient, rootUrl: string, params?: GetManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyRecoveringCharacteristicResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic.PATH, 'get');
  if (params) {
    rb.query('fields', params.fields, {});
    rb.query('s', params.s, {});
    rb.query('filter', params.filter, {});
    rb.query('or', params.or, {});
    rb.query('sort', params.sort, {});
    rb.query('join', params.join, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('page', params.page, {});
    rb.query('cache', params.cache, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetManyRecoveringCharacteristicResponseDto>;
    })
  );
}

getManyBaseMgmtRecoveringCharacteristicControllerRecoveringCharacteristic.PATH = '/api/mgmt/recovering-characteristic';
